import { render, staticRenderFns } from "./AssociarDocumentoDespesa.vue?vue&type=template&id=0145f37e"
import script from "./AssociarDocumentoDespesa.vue?vue&type=script&lang=js"
export * from "./AssociarDocumentoDespesa.vue?vue&type=script&lang=js"
import style0 from "./AssociarDocumentoDespesa.vue?vue&type=style&index=0&id=0145f37e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports